import React from 'react';
import { Link } from 'react-router-dom';

// Routes internal paths ("/about", "/#features") through the router and leaves
// in-page anchors, mailto: and external URLs as plain anchors.
const SmartLink = ({ to, children, ...rest }) => {
  if (to.startsWith('/')) {
    return (
      <Link to={to} {...rest}>
        {children}
      </Link>
    );
  }
  const external = /^https?:\/\//.test(to);
  return (
    <a href={to} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} {...rest}>
      {children}
    </a>
  );
};

export default SmartLink;
